import { API_BASE_URL } from "../../constant/constant";
import React, { useState, useEffect } from "react";
import Switch from "@mui/material/Switch";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from '@mui/material/Tooltip';
import {
  MaskingInput,
  MaskingInputLabel,
  MaskingInputList,
  MaskingInputListItem,
  MaskingInputListItemLabel,
  MaskingTypes,
  Footer,
  FooterButton,
} from "./Style";
import InfoIcon from "../../assets/info.svg";
import { MaskingInfo } from "../../Components/Constants/Constants";
import { useTranslation } from "react-i18next";

const GeneralSettings = () => {
  const { t } = useTranslation();
  const [masking, setMasking] = useState(false);
  const [maskingTypes, setMaskingTypes] = useState([
    {
      type: "CREDIT_CARD",
      enabled: false,
    },
    {
      type: "CRYPTO",
      enabled: false,
    },
    {
      type: "DATE_TIME",
      enabled: false,
    },
    {
      type: "EMAIL_ADDRESS",
      enabled: false,
    },
    {
      type: "IBAN_CODE",
      enabled: false,
    },
    {
      type: "IP_ADDRESS",
      enabled: false,
    },
    {
      type: "NRP",
      enabled: false,
    },
    {
      type: "LOCATION",
      enabled: false,
    },
    {
      type: "PERSON",
      enabled: false,
    },
    {
      type: "PHONE_NUMBER",
      enabled: false,
    },
    {
      type: "MEDICAL_LICENSE",
      enabled: false,
    },
    { type: "URL", enabled: false },
    {
      type: "US_BANK_NUMBER",
      enabled: false,
    },
    {
      type: "US_DRIVER_LICENSE",
      enabled: false,
    },
    {
      type: "US_ITIN",
      enabled: false,
    },
    {
      type: "US_PASSPORT",
      enabled: false,
    },
    {
      type: "US_SSN",
      enabled: false,
    },
    {
      type: "UK_NHS",
      enabled: false,
    },
    {
      type: "UK_NINO",
      enabled: false,
    },
    {
      type: "ES_NIF",
      enabled: false,
    },
    {
      type: "ES_NIE",
      enabled: false,
    },
    {
      type: "IT_FISCAL_CODE",
      enabled: false,
    },
    {
      type: "IT_DRIVER_LICENSE",
      enabled: false,
    },
    {
      type: "IT_VAT_CODE",
      enabled: false,
    },
    {
      type: "IT_PASSPORT",
      enabled: false,
    },
    {
      type: "IT_IDENTITY_CARD",
      enabled: false,
    },
    {
      type: "PL_PESEL",
      enabled: false,
    },
    {
      type: "SG_NRIC_FIN",
      enabled: false,
    },
    {
      type: "SG_UEN",
      enabled: false,
    },
    {
      type: "AU_ABN",
      enabled: false,
    },
    {
      type: "AU_ACN",
      enabled: false,
    },
    {
      type: "AU_TFN",
      enabled: false,
    },
    {
      type: "AU_MEDICARE",
      enabled: false,
    },
  
    {
      type: "FI_PERSONAL_IDENTITY_CODE",
      enabled: false,
    },
  ]);
  const [isLoading, setIsLoading] = useState(false);

  const handleMaskingTypeChange = (index) => {
    if (masking) {
      const updatedMaskingTypes = [...maskingTypes];
      updatedMaskingTypes[index].enabled = !updatedMaskingTypes[index].enabled;
      setMaskingTypes(updatedMaskingTypes);
    }
  };

  const handleMaskingChange = () => {
    const newMaskingState = !masking;
    setMasking(newMaskingState);

    if (newMaskingState) {
      // When masking is turned on, enable all masking types
      const updatedMaskingTypes = maskingTypes.map(type => ({
        ...type,
        enabled: true
      }));
      setMaskingTypes(updatedMaskingTypes);
    }
  };

  useEffect(() => {
    handleGetMaskingTypes();
  }, []);
  const handleSaveMaskingTypes = async () => {
    try {
      setIsLoading(true);
      const userId = localStorage.getItem("id");
      const maskingData = maskingTypes.map((item) => ({
        key: item.type,
        value: item.enabled,
      }));
      const requestBody = {
        userId: userId,
        masking: masking,
        maskingData: maskingData,
      };
      const response = await fetch(
        `${API_BASE_URL}/api/auth/editMasking`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );
      const data = await response.json();
      console.log(data);
    } catch (error) {
      console.error("Error saving masking types:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGetMaskingTypes = async () => {
    const userId = localStorage.getItem("id");
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/auth/getMasking?userId=${userId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();
      if (data.responseCode === 200) {
        setMasking(data.masking);
        const updatedMaskingTypes = maskingTypes.map((type) => {
          const foundType = data.maskingData.find(
            (item) => item.key === type.type
          );
          return {
            ...type,
            enabled: foundType ? foundType.value : type.enabled,
            _id: foundType ? foundType._id : undefined,
          };
        });
        setMaskingTypes(updatedMaskingTypes);
      }
    } catch (error) {
      console.error("Error fetching masking types:", error);
    }
  };

  return (
    <>
      <MaskingInput>
        <MaskingInputLabel>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
          >
            <path
              d="M5.12728 13.2053C3.92817 13.2053 2.90617 12.7828 2.06128 11.9379C1.21639 11.093 0.793945 10.071 0.793945 8.87192C0.793945 7.6727 1.21639 6.6507 2.06128 5.80592C2.90617 4.96103 3.92817 4.53859 5.12728 4.53859C6.3265 4.53859 7.3485 4.96103 8.19328 5.80592C9.03817 6.6507 9.46061 7.6727 9.46061 8.87192C9.46061 10.071 9.03817 11.093 8.19328 11.9379C7.3485 12.7828 6.3265 13.2053 5.12728 13.2053ZM5.12728 12.2053C6.0495 12.2053 6.83561 11.8803 7.48561 11.2303C8.13561 10.5803 8.46061 9.79414 8.46061 8.87192C8.46061 7.9497 8.13561 7.16359 7.48561 6.51359C6.83561 5.86359 6.0495 5.53859 5.12728 5.53859C4.20506 5.53859 3.41895 5.86359 2.76895 6.51359C2.11895 7.16359 1.79395 7.9497 1.79395 8.87192C1.79395 9.79414 2.11895 10.5803 2.76895 11.2303C3.41895 11.8803 4.20506 12.2053 5.12728 12.2053ZM10.2349 9.22309C10.2486 9.16931 10.2554 9.1137 10.2554 9.05625V8.87192C10.2554 7.45392 9.75528 6.2447 8.75494 5.24426C7.7545 4.24392 6.54528 3.74375 5.12728 3.74375H4.94295C4.8855 3.74375 4.82989 3.75059 4.77611 3.76425C5.03078 2.94881 5.52456 2.25009 6.25745 1.66809C6.99033 1.08598 7.8615 0.794922 8.87094 0.794922C10.0701 0.794922 11.0921 1.21737 11.9369 2.06225C12.7818 2.90714 13.2043 3.92914 13.2043 5.12825C13.2043 6.1377 12.9132 7.00887 12.3311 7.74175C11.7491 8.47464 11.0504 8.96842 10.2349 9.22309Z"
              fill="#22272F"
            />
          </svg>
          <span>{t("profile.general.masking")}</span>
          <Tooltip title={MaskingInfo}>
            <img src={InfoIcon} alt="info" />
          </Tooltip>

        </MaskingInputLabel>
        <Switch checked={masking} onChange={handleMaskingChange} />
      </MaskingInput>
      {masking && (
        <MaskingTypes style={{ overflowY: "auto" }}>
          <MaskingInputList>
            {maskingTypes.map((item, index) => (
              <MaskingInputListItem key={index}>
                <Switch
                  checked={item.enabled && masking}
                  onChange={() => handleMaskingTypeChange(index)}
                  disabled={!masking}
                />
                <MaskingInputListItemLabel>
                  <span style={{ fontWeight: "600" }}>{item.type} :</span>
                  <span>{t(`profile.general.maskingTypes.${item.type}`)}</span>
                </MaskingInputListItemLabel>
              </MaskingInputListItem>
            ))}
          </MaskingInputList>
        </MaskingTypes>
      )}
      <Footer>
        <FooterButton onClick={handleSaveMaskingTypes} disabled={isLoading}>
          {isLoading ? <CircularProgress size={16} /> : <span>{t("profile.general.save")}</span>}
        </FooterButton>
      </Footer>
    </>
  );
};

export default GeneralSettings;